import React from 'react'
import {
  asyncWithLDProvider,
  useFlags as useFeatureFlag,
} from 'launchdarkly-react-client-sdk'
import FeatureFlagIdentitySync from './FeatureFlagIdentitySync'

export const createFeatureFlagProvider = async store => {
  const LaunchDarklyProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID,
    deferInitialization: true,
    user: {
      key: 'pre-init-fixed-key',
    },
  })

  return ({ children }) => {
    return (
      <LaunchDarklyProvider>
        <FeatureFlagIdentitySync />
        {children}
      </LaunchDarklyProvider>
    )
  }
}

export const useFlags = props => useFeatureFlag(props)
